export default {
  ratePlanType: {
    STANDARD: 'Standard',
    BAR: 'Miglior tariffa disponibile',
    CORPORATE: 'Aziendale',
    MEMBER: 'Membri',
    PACKAGE: 'Pacchetto',
    PROMOTIONAL: 'Promozionale',
    OTA: 'OTA',
    WHOLESALE: 'Ingrosso',
    NEGOTIATED: 'Negoziata',
    MIXED: 'Tariffa combinata',
  },
} as const;
